import Splide from "@splidejs/splide";

export const lineupSlider = () => {
  if (document.querySelector(".js-lineup-slider") === null) {
    return;
  }

  const sliders = document.getElementsByClassName("js-lineup-slider");

  for (let i = 0; i < sliders.length; i++) {
    new Splide(sliders[i], {
      type: "loop",
      speed: 1000,
      gap: "2rem",
      lazyLoad: "nearby",
      classes: {
        pagination: "splide__pagination lineup-slider__pagination",
        page: "splide__pagination__page lineup-slider__page",
        arrows: "splide__arrows lineup-slider__arrows",
        arrow: "splide__arrow lineup-slider__arrow",
        prev: "splide__arrow--prev -prev",
        next: "splide__arrow--next -next",
      },
      breakpoints: {
        768: {
          arrows: false,
        },
      },
    }).mount();
  }
};
